import React, { Component, createRef } from "react";
import layers_icon from "../../assets/images/layers_icon.png";
import "./Header.scss";
import SearchIcon from "@material-ui/icons/Search";
import go_to_icon from "../../assets/images/go_to_icon.png";
import {
  AddressInfo,
  SearchOption,
  LanguageOption,
  Coordinates,
} from "../../entities/iconData";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { BrowserLanguage } from "../../entities/BrowserLanguage";
import location_icon from "../../assets/images/location_icon.png";
import israel_icon from "../../assets/images/israel.png";
import russia_icon from "../../assets/images/russia.png";
import united_arab_icon from "../../assets/images/united-arab.png";
import united_states_icon from "../../assets/images/united-states.png";
import language_icon from "../../assets/images/language.svg";
import station_1_icon from "../../assets/images/station_1_icon.png";
import station_2_icon from "../../assets/images/station_2_icon.png";
import busy_station_icon from "../../assets/images/busy_station_icon.png";
import inactive_station_icon from "../../assets/images/inactive_station_icon.png";
import comingSoon_station_icon from "../../assets/images/comingSoon_station_icon.png";
import { LayersFilters } from "../../entities/LayersFilters";
import filter_icon from "../../assets/images/filter_icon.png";
import { StringsData } from "../../entities/StringsData";
import { slide as Menu } from "react-burger-menu";
import Popup from "../Popup/Popup";
import contact_us_icon from "../../assets/images/contact_us_icon.png";
import gmap from "../../assets/images/google-maps-icon.svg.png";
import { PopupType } from "../../entities/PopupType";
import { Icon, Popper } from "@material-ui/core";
import { kMaxLength } from "buffer";

class Header extends Component<HeaderProps, HeaderState> {
  languageSelectRef = createRef<HTMLSelectElement>();
  menuRef = createRef<HTMLDivElement>();
  lastFocusedElement: HTMLElement | null = null;

  getLanguageButtonLabel = () => {
    const { browserLanguage } = this.props;

    switch (browserLanguage) {
      case BrowserLanguage.he:
        return "בחירת שפה, תפריט נפתח";
      case BrowserLanguage.ar:
        return "اختيار اللغة، قائمة منسدلة";
      case BrowserLanguage.ru:
        return "Выбор языка, выпадающее меню";
      case BrowserLanguage.en:
      default:
        return "Language selection, menu closed";
    }
  };

  getLanguageSelectLabel = () => {
    const { browserLanguage } = this.props;

    switch (browserLanguage) {
      case BrowserLanguage.he:
        return "בחירת שפה";
      case BrowserLanguage.ar:
        return "اختيار اللغة";
      case BrowserLanguage.ru:
        return "Выбор языка";
      case BrowserLanguage.en:
      default:
        return "Language selection";
    }
  };

  getLanguageSelectAriaLabel = () => {
    const { browserLanguage } = this.props;
    switch (browserLanguage) {
      case BrowserLanguage.he:
        return "מעבר לאתר בעברית";
      case BrowserLanguage.ar:
        return "Switch to Hebrew site";
      case BrowserLanguage.ru:
        return "Переключиться на сайт на иврите";
      case BrowserLanguage.en:
      default:
        return "Switch to Arabic site";
    }
  };

  constructor(props: HeaderProps) {
    super(props);
    this.state = {
      openMenuBar: false,
      openPopup: false,
      popupType: PopupType.EMPTY,
      portalView: false,
      languageMenuOpen: false, // controls the react-select dropdown open state
      languageLiveMessage: "",
      focusedOptionIdx: 0, 
    };
  }

  componentDidMount = () => {
    const portal = window.location.search.includes("portal");
    this.setState({ portalView: portal });
  };

  componentDidUpdate(prevProps: HeaderProps, prevState: HeaderState) {
    // Handle menu focus trap
    if (this.props.openMenuBar && !prevProps.openMenuBar) {
      this.lastFocusedElement = document.activeElement as HTMLElement;
      this.setupFocusTrap();
    } else if (!this.props.openMenuBar && prevProps.openMenuBar) {
      this.removeFocusTrap();
      this.lastFocusedElement?.focus();
    }
  }

  setupFocusTrap = () => {
    if (!this.menuRef.current) return;

    const focusableElements =
      this.menuRef.current.querySelectorAll<HTMLElement>(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    const handleTabKey = (e: KeyboardEvent) => {
      if (e.key === "Tab") {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }
    };

    document.addEventListener("keydown", handleTabKey);
    this.setState({ focusTrapHandler: handleTabKey });
  };

  removeFocusTrap = () => {
    if (this.state.focusTrapHandler) {
      document.removeEventListener("keydown", this.state.focusTrapHandler);
      this.setState({ focusTrapHandler: undefined });
    }
  };

  // Toggle the language dropdown state
  toggleLanguageMenu = () => {
    this.setState((prevState) => ({
      languageMenuOpen: !prevState.languageMenuOpen,
    }));
  };

  // Listen for keyboard events on the parent container and toggle dropdown on Enter
  handleLanguageKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      this.toggleLanguageMenu();
    }
  };

  render() {
    const {
      browserLanguage,
      stringsFromServer,
      closeAllPopupsFunc,
      setSelectedStationCoordinates,
    } = this.props;
    const direction =
      browserLanguage === "ar" || browserLanguage === "he" ? "rtl" : "ltr";
    return (
      <header className={`header-page ${browserLanguage}`}>
        <div
          aria-live="polite"
          aria-atomic="true"
          style={{
            position: "absolute",
            left: "-9999px",
            width: "1px",
            height: "1px",
            overflow: "hidden",
          }}
        >
          {this.state.languageLiveMessage}
        </div>
        {!this.state.portalView && (
          <div className={`title-header ${browserLanguage} desktop-only`}>
            <img
              className={`title-header-img ${browserLanguage}`}
              src={station_1_icon}
              alt="staion icon"
            />
            <span className={`title-header-text ${browserLanguage}`}>
              {stringsFromServer.site_MainHeader}
            </span>
          </div>
        )}
        {/*
        <div className={`layers ${browserLanguage}`}
          onClick={() => this.props.layersPopup()}
        >
          <img src={layers_icon} alt="layers icon" />
        </div>
        */}
        <div className={`language-search ${browserLanguage} desktop-only`}>
          <div className={`search ${browserLanguage}`}>
            <Autocomplete
              id="combo-box-demo"
              fullWidth={true}
              forcePopupIcon={false}
              PopperComponent={(props: any) => (
                <Popper
                  {...props}
                  style={{ width: "23vw", direction: direction }}
                />
              )}
              style={{ direction: direction }}
              options={this.searchStations()}
              getOptionLabel={(option: SearchOption) =>
                option.name + " - " + option.address
              }
              onChange={(event: any, newValue: SearchOption | null) =>
                this.props.setSelectedStationCoordinates(newValue)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  style={{ width: "23vw", direction: direction }}
                  label={
                    <div className={`label-search-text ${browserLanguage}`}>
                      <SearchIcon /> {stringsFromServer.site_SearchText}
                    </div>
                  }
                  variant="outlined"
                  size="small"
                ></TextField>
              )}
              renderOption={(option: SearchOption) => (
                <div>
                  <div className="select-station-div">
                    <span className="select-name-img">
                      <img
                        src={this.getCorrectStationIcon(option.status)}
                        alt="station icon"
                      ></img>
                      {option.name}
                      {option.address ? " - " + option.address : " "}
                    </span>
                    <div className={`distance-from-user ${browserLanguage}`}>
                      {" "}
                      {this.getStringDistance(option.distanceFromUser)}{" "}
                    </div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
        {/* Desktop language select wrapped in a focusable div so that Enter toggles the dropdown. */}
        <div className={`language-select desktop-only ${browserLanguage}`}>
          <img
            className="language-icon"
            src={language_icon}
            alt={this.getLanguageSelectAriaLabel()}
          />

          <div className="select-wrapper">{this.languageSelect(true)}</div>
        </div>

        <div className="mobile-mode header-mobile">
          {this.getPopupTitleFilter()}
          <div className={`title-header ${browserLanguage} mobile-mode`}>
            <img
              className={`title-header-img ${browserLanguage}`}
              src={station_1_icon}
              alt="staion icon"
            />
            <span className={`title-header-text ${browserLanguage}`}>
              {stringsFromServer.site_MainHeader}
            </span>
          </div>
          <div className={`side-bar ${browserLanguage}`}>
            <div
              className={
                this.props.openMenuBar
                  ? "humburger humburger-open"
                  : "humburger"
              }
              onClick={() => {
                this.props.toggleMenuBar();
                this.props.closeAllPopupsFunc();
              }}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
            {this.props.openMenuBar ? (
              <div
                ref={this.menuRef}
                className={`menu-side-bar ${browserLanguage}`}
                onClick={(e) => e.stopPropagation()}
              >
                <div className={`search ${browserLanguage}`}>
                  <Autocomplete
                    id="combo-box-demo"
                    forcePopupIcon={false}
                    fullWidth={true}
                    PopperComponent={(props: any) => (
                      <Popper
                        {...props}
                        style={{ width: "300px", direction: direction }}
                      />
                    )}
                    options={this.searchStations()}
                    getOptionLabel={(option: SearchOption) =>
                      option.name + " - " + option.address
                    }
                    onChange={(event: any, newValue: SearchOption | null) => {
                      this.setState({ openMenuBar: false });
                      setSelectedStationCoordinates(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <div
                            className={`label-search-text ${browserLanguage}`}
                          >
                            <SearchIcon /> {stringsFromServer.site_SearchText}
                          </div>
                        }
                        variant="outlined"
                        size="small"
                      ></TextField>
                    )}
                    renderOption={(option: SearchOption) => (
                      <div>
                        <div className="select-station-div">
                          <span className="select-name-img">
                            <img
                              src={this.getCorrectStationIcon(option.status)}
                              alt="station icon"
                            ></img>
                            {option.name}
                            {option.address ? " - " + option.address : " "}
                          </span>
                          <div
                            className={`distance-from-user ${browserLanguage}`}
                          >
                            {" "}
                            {this.getStringDistance(
                              option.distanceFromUser
                            )}{" "}
                          </div>
                        </div>
                        <div className="Navgo-to">
                          <img
                            alt="gmap"
                            src={gmap}
                            onClick={() => this.googleMapsNavigation(option)}
                          />
                          <span className={`Navlabel ${browserLanguage}`}>
                            {" "}
                            {stringsFromServer.site_StationInfoNavigate}{" "}
                          </span>
                        </div>
                      </div>
                    )}
                  />
                </div>
                {/*
                  Mobile language select – no need for the ref here.
                */}
                <div
                  className={`language-select-wrapper ${browserLanguage}`}
                  onClick={this.toggleLanguageMenu}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      this.toggleLanguageMenu();
                    }
                  }}
                  role="button"
                  tabIndex={0}
                  aria-label={this.getLanguageSelectAriaLabel()}
                >
                  <img
                    src={language_icon}
                    alt={this.getLanguageSelectAriaLabel()}
                    className="language-icon"
                  />
                  {this.languageSelect(false)}
                </div>

                <div className="center">
                  <a
                    className="terms"
                    onClick={() => this.openPopup(PopupType.TERMS_OF_USE)}
                  >
                    <span className="footer-text">
                      {" "}
                      {stringsFromServer.site_TermsOfUse}
                    </span>
                  </a>
                  <div
                    className="accessibillty"
                    onClick={() =>
                      this.openPopup(PopupType.ACCESSIBILITY_STATMENT)
                    }
                  >
                    <span className="footer-text">
                      {stringsFromServer.site_AccessbillityText}
                    </span>
                  </div>
                  <div
                    className={`contact-us ${browserLanguage}`}
                    onClick={() => this.openPopup(PopupType.POPUP_CONTACT)}
                  >
                    <span className="footer-text">
                      {" "}
                      {stringsFromServer.site_ContactText}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className={`not-show-menu-bar ${browserLanguage}`}></div>
            )}
          </div>
          {this.state.openPopup && (
            <Popup
              stringsFromServer={stringsFromServer}
              openPopup={this.state.openPopup}
              closePopup={this.closePopup}
              popupType={this.state.popupType}
              browserLanguage={browserLanguage}
            ></Popup>
          )}
        </div>
      </header>
    );
  }

  getStringDistance = (distance: number) => {
    const KM = this.props.browserLanguage === "he" ? 'ק"מ' : "Km";
    if (!distance) return "";
    if (distance < 1) {
      return distance.toString().slice(0, 4) + " " + KM;
    }
    return " " + Math.floor(distance) + " " + KM;
  };

  /**
   * languageSelect accepts a parameter attachRef.
   * If attachRef is true, we attach a ref to the Select component so that we can call .focus()
   * on it when the dropdown is opened via keyboard.
   */
  languageSelect = (attachRef: boolean = false) => {
    const options: LanguageOption[] = [
      { value: BrowserLanguage.he, label: "עברית", ariaLabel: "מעבר לאתר בעברית" },
      { value: BrowserLanguage.en, label: "English", ariaLabel: "מעבר לאתר באנגלית" },
      { value: BrowserLanguage.ar, label: "عربي", ariaLabel: "מעבר לאתר בערבית" },
      { value: BrowserLanguage.ru, label: "русский", ariaLabel: "מעבר לאתר ברוסית" },
    ];
    document.documentElement.lang = this.props.browserLanguage;
    
    return (
      <div
        role="combobox"
        aria-haspopup="listbox"
        aria-expanded={this.state.languageMenuOpen}
        aria-activedescendant={this.state.languageMenuOpen ? `language-option-${this.state.focusedOptionIdx}` : undefined}
      >
        <span id="language-select-label" className="sr-only" style={{position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden'}}>
          {this.getLanguageSelectLabel()}
        </span>
        <select
          id="language-select"
          ref={attachRef ? this.languageSelectRef : null}
          className={`language-select-native ${this.props.browserLanguage}`}
          value={this.props.browserLanguage}
          onChange={(e) => {
            this.handleChangeLanguage(e.target.value);
            this.setState({
              languageMenuOpen: false,
              languageLiveMessage: `השפה שונתה ל${e.target.options[e.target.selectedIndex].text}`,
              focusedOptionIdx: e.target.selectedIndex,
            });
          }}
          onFocus={() => this.setState({ focusedOptionIdx: this.props.browserLanguage === BrowserLanguage.he ? 0 : 
            this.props.browserLanguage === BrowserLanguage.en ? 1 : 
            this.props.browserLanguage === BrowserLanguage.ar ? 2 : 3 })}
          aria-labelledby="language-select-label"
        >
          {options.map((option, index) => (
            <option
              key={option.value}
              value={option.value}
              id={`language-option-${index}`}
              aria-label={option.ariaLabel}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  };

  getCorrectStationIcon(status: number): string {
    switch (status) {
      case LayersFilters.AVAILABLE:
        return station_2_icon;
      case LayersFilters.BUSY:
        return busy_station_icon;
      case LayersFilters.INACTIVE:
        return inactive_station_icon;
      case LayersFilters.COMING_SOON:
        return comingSoon_station_icon;
      default:
        return station_2_icon;
    }
  }

  searchStations = (): SearchOption[] => {
    const criteriaSearchArr = this.props.addressInfoData.map(
      (addressInfo: AddressInfo) => {
        const searchOption = {
          name: addressInfo.name ? addressInfo.name : "",
          address: addressInfo.streetName,
          id: addressInfo.id,
          status: addressInfo.status,
          connectorTypesArr: addressInfo.moreInfoStationData
            ? addressInfo.moreInfoStationData.connectorTypesArr
            : [],
          distanceFromUser: addressInfo.distanceFromUser,
        };
        return searchOption;
      }
    );
    return criteriaSearchArr.sort(
      (a, b) => a.distanceFromUser - b.distanceFromUser
    );
  };

  wazeNavigation = (searchOpt: SearchOption) => {
    let addressInfo = this.props.addressInfoData.filter(
      (adrr) => adrr.id === searchOpt.id
    );
    const wazeBaseUrl = "https://www.waze.com/";
    const wazeLanguage = this.getWazeLanguage();
    const wazeTo = "to=ll." + addressInfo[0].lat + "%2C" + addressInfo[0].lng;
    const wazeFrom = !this.props.userLocation
      ? ""
      : "&from=ll." +
        this.props.userLocation.lat +
        "%2C" +
        this.props.userLocation.lng;
    const wazeURL =
      wazeBaseUrl + wazeLanguage + "live-map/directions?" + wazeTo + wazeFrom;
    window.open(wazeURL, "_blank");
  };

  getWazeLanguage(): string {
    switch (this.props.browserLanguage) {
      case "ru":
      case "ar":
      case "he": {
        return this.props.browserLanguage + "/";
      }
      case "en-US":
      default: {
        return "";
      }
    }
  }

  googleMapsNavigation = (searchOpt: SearchOption) => {
    let addressInfo = this.props.addressInfoData.filter(
      (adrr) => adrr.id === searchOpt.id
    );
    const googleMapsUrl =
      "https://www.google.com/maps/?q=" +
      addressInfo[0].lat +
      "," +
      addressInfo[0].lng;
    window.open(googleMapsUrl, "_blank");
  };

  handleChangeLanguage = (newLanguage: string) => {
    this.props.changeLanguage(newLanguage);
    let langLabel = "";
    switch (newLanguage) {
      case "he":
        langLabel = "עברית";
        break;
      case "en":
        langLabel = "English";
        break;
      case "ar":
        langLabel = "ערבית";
        break;
      case "ru":
        langLabel = "רוסית";
        break;
      default:
        langLabel = newLanguage;
    }
    this.setState({ languageLiveMessage: `השפה הנבחרת: ${langLabel}` });
  };

  getPopupTitleFilter = () => {
    return (
      <div
        className={`title-filter-mobile mobile-mode ${this.props.browserLanguage}`}
        onClick={() => {
          this.props.filterPopup();
        }}
      >
        <span className="title-img">
          <img src={filter_icon} alt="filter icon" />
        </span>
      </div>
    );
  };

  openPopup = (popupType: PopupType) => {
    this.setState({ openPopup: true, popupType });
    this.props.closeAllPopupsFunc();
  };

  closePopup = () => {
    this.setState({ openPopup: false });
  };
}

interface HeaderProps {
  browserLanguage: BrowserLanguage;
  addressInfoData: AddressInfo[];
  setSelectedStationCoordinates: Function;
  filterPopup: Function;
  layersPopup: Function;
  changeLanguage: Function;
  stringsFromServer: StringsData;
  closeAllPopupsFunc: Function;
  userLocation?: Coordinates;
  toggleMenuBar: () => void;
  openMenuBar: boolean;
}

interface HeaderState {
  openMenuBar: boolean;
  openPopup: boolean;
  popupType: PopupType;
  portalView: boolean;
  languageMenuOpen: boolean;
  languageLiveMessage: string;
  focusedOptionIdx: number; // הוסף focusedOptionIdx ל-state בקונסטרקטור בלבד
  focusTrapHandler?: (e: KeyboardEvent) => void;
}

export default Header;
